<div class="main-table">
  <table class="table" matSort (matSortChange)="onSortTable($event)">
   <thead>
      <tr>
        <ng-container *ngFor="let tableColumn of tableColumns">
          <th [class.custom-bg-th]="tableColumn.border">
            <span class="header_label">
              {{ tableColumn?.columnName | translate }}
              <span class="text-transform-normal">
                {{ tableColumn?.symbol | reportDataValueType : current_lang }}
              </span>
            </span>
          </th>
        </ng-container>
      </tr>
    </thead>

    <tbody>
      <tr *ngFor="let element of tableData" [ngClass]="{ hideTable: showLoader }"
        [style.background-color]="element['outlier'] ? '#FFE1E1' : element?.bgColor">
        <td>{{ element?.type ?? '-' }}</td>
        <td>{{ element?.avg_size ? (element.avg_size | number:'1.0-1') : '-' }}</td>
        <td>{{ element?.avg_rental_lumpsum ? (element.avg_rental_lumpsum | number:'1.0-1') : '-' }}</td>
        <td>{{ element?.avg_rental_rate ? (element.avg_rental_rate | number:'1.0-1') : '-' }}</td>
      </tr>

      <tr *ngIf="showLoader" style="height: auto;">
        <td [attr.colspan]="tableColumns.length">
          <app-skeleton-loader [loaderSize]="5"></app-skeleton-loader>
        </td>
      </tr>
    </tbody>
  </table>
</div>
